module.exports = __webpack_public_path__ + "img/Patch6.2.86813d73.webp";